/* eslint-disable no-irregular-whitespace */
<script>

export default {
  name: 'Mention'
};
</script>

<template>
  <div class="content">
    <h2 class="primary--text mb-6">
      <u><b>MENTIONS LEGALES DU SITE DE COMMANDE D’ALIMENTS</b></u>
    </h2>
    <p> Les mentions légales du site de commande d’aliments https://www.commande-aliments.agrial.com (ci-après le &laquo; Site &raquo;) sont indiquées ci-dessous.</p>

    <h3 class="secondary--text">
      1. Mentions légales obligatoires
    </h3>

    <p><b><i>1.1. Editeur du site</i></b></p>

    <p>Ce Site est la propriété d’AGRIAL, éditrice du Site.</p>
    <p>
      Société coopérative agricole et agro-alimentaire AGRIAL<br>
      Société Coopérative agricole à capital variable <br>
      Dont le siège social est 4 rue des Roquemonts 14000 CAEN<br>
      SIREN 428 611 719 RCS CAEN<br>
      TVA : FR 65 428 611 719<br>
      SIRET : 428 611 719 00017<br>
      Téléphone (standard) : +33(0)2 31 45 43 43 <br>
    </p>

    <p>Adresse électronique : webmaster@agrial.com </p>
    <p>Directeur de la publication : Monsieur Nicolas LAIGLE, Directeur Général de la Branche Agricole et Directeur de la Coopérative</p>

    <p><b><i>1.2. Hébergeur du Site </i></b></p>

    <p>
      Ce Site est hébergé par AGRIAL – Direction Systèmes d’Information<br>
      Siège social : 4 rue des Roquemonts 14000 CAEN<br>
      RCS CAEN 428 611 719<br>
      Tel : 02 31 45 43 43<br>
      Email : webmaster@agrial.com<br>
    </p>

    <h3 class="secondary--text">
      2. Liens vers d’autres sites
    </h3>
    <p>Afin de faciliter l’accès à d’autres sites, AGRIAL se réserve la possibilité d’insérer un certain nombre de liens vers des sites tiers. Cependant, AGRIAL n’est pas responsable de l’indisponibilité des sites tiers, de leur contenu, publicité ou autres éléments disponibles sur ces sites. La responsabilité du propriétaire de ce Site ne saurait donc être engagée au titre d’un site tiers auquel l’utilisateur aurait pu avoir accès.</p>
    <p>Des sites externes peuvent contenir des liens hypertextes pointant vers ce Site. Un tel lien ne pourra être installé sans un accord préalable et écrit d’AGRIAL.</p>

    <h3 class="secondary--text">
      3. Gestion des cookies
    </h3>
    <p>Ce Site est susceptible d’utiliser des cookies qui sont des fichiers stockés sur l’ordinateur de l’utilisateur permettant une facilité d’accès aux services proposés. En aucun cas, les cookies de ce Site ne pourront servir à collecter des données personnelles sans l’accord exprès de l’utilisateur. </p>

    <p>L’utilisateur a la possibilité d’accepter ou de refuser les cookies via la page dédiée à cet effet présente sur le Site.</p>

    <p>L’utilisateur peut accepter les cookies soit globalement soit finalité par finalité ; si l’utilisateur refuse certains cookies, il se peut que l’accès ou certaines fonctionnalités du Site ne fonctionnent pas.</p>

    <p>Pour plus d’informations sur les cookies, l’utilisateur peut consulter la page dédiée aux cookies sur le Site et/ou le site www.cnil.fr.</p>

    <p>En tout état de cause, la durée de conservation de ces cookies est d’une durée maximale de 13 mois.</p>
    <h3 class="secondary--text">
      4. Propriété intellectuelle
    </h3>

    <p>En se connectant sur le Site internet édité par AGRIAL, titulaire de l'ensemble des droits de propriété intellectuelle s'y rapportant, l’utilisateur ne peut pas copier ni télécharger tout ou partie de son contenu, sauf autorisation préalable et exprès d’AGRIAL.</p>
    <p>Le Site ainsi que l’ensemble de son contenu (notamment les photos, logos, marques et information de toute nature y figurant) sont protégés par le droit d’auteur. AGRIAL concède aux utilisateurs de son Site internet une simple autorisation de visualisation excluant notamment la réutilisation de tout ou partie du contenu de ce Site pour quelque motif que ce soit.</p>
    <p>Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables (logos, photos, informations de toute nature ou autre). Les documents à télécharger sont également protégés par le droit d’auteur. Les limites de l’utilisation de ces documents sont précisées sur les pages du Site concernées.</p>
    <p>Toute représentation totale ou partielle du Site sans l’autorisation exprès d’AGRIAL– Service communication Agrial, est interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle. Il en est de même, s’il y a lieu, des bases de données figurant sur le Site, qui sont protégées par les dispositions de la loi du 1er juillet 1998 portant transposition dans le Code de la propriété intellectuelle de la directive européenne du 11 mars 1996 relative à la protection juridique des bases de données.</p>
    <p>De même, tout enregistrement, radiodiffusion, traduction et adaptation, totale ou partielle du Site, est interdit.</p>

    <h3 class="secondary--text">
      5. Gestion des données personnelles
    </h3>

    <p>AGRIAL ne collecte des informations personnelles relatives à l’utilisateur que pour le besoin de certains services proposés par le Site. L’utilisateur fournit ces informations en toute connaissance de cause, notamment lorsqu’il procède par lui-même à leur saisie. Il est alors précisé à l’utilisateur du Site l’obligation ou non de fournir ces informations.</p>
    <p>La politique d’AGRIAL relative à la protection des données personnelles est accessible sur le Site monagrial (en footer). </p>
    <p>L’utilisateur dispose des droits d'accès, de rectification, de suppression et de portabilité des données qui le concernent, ainsi que du droit de demander la limitation ou de s’opposer au traitement de celles-ci. </p>

    <p>
      L’utilisateur pourra exercer ses droits de la manière suivante :
      <ul>
        <li>Par voie postale, en écrivant à : Agrial – Service commande d’aliments, 45 rue Louis Lumière 35133 La Selle en Luitré </li>
        <li>Par courriel adressé à contact.commande-aliments@agrial.com en indiquant comme objet du courriel &laquo;Données personnelles : droit d’accès –commande d’aliments&raquo;. </li>
      </ul>
    </p>
    <p>Il pourra être demandé à l’utilisateur de justifier de son identité pour le bon exercice de ses droits.</p>
    <p>Aucune information personnelle de l’utilisateur n’est publiée à l’insu de l’utilisateur, cédée ou vendue sur un support quelconque à des tiers.</p>

    <h3 class="secondary--text">
      6. Limitations de responsabilités
    </h3>

    <p>Le propriétaire de ce Site se réserve le droit de modifier son contenu à tout moment et sans préavis. Il ne pourra être tenu responsable des conséquences de telles modifications. De même, il se réserve le droit d’interrompre ou de suspendre tout ou partie des fonctionnalités du Site à tout moment et sans préavis.</p>
    <p>AGRIAL ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au Site, et résultant de l’apparition d’un bug ou d’une incompatibilité. </p>
    <p>AGRIAL fournit des informations à des fins purement informatives. Il s’efforce de contrôler leur exactitude et de les maintenir à jour. Mais aucune garantie n’est apportée concernant l’exactitude, la précision, la mise à jour ou l’exhaustivité de ces informations. </p>
    <p>Par conséquent, AGRIAL décline toute responsabilité pour tout dommage résultant notamment d’une imprécision ou inexactitude des informations disponibles sur ce Site, ou pour toute atteinte résultant d’une intrusion frauduleuse d’un tiers sur ce Site, ou encore pour tout dommage ou virus qui pourrait endommager ou rendre inutilisable l’équipement informatique de l’utilisateur suite à la visite de ce Site.</p>
    <p>AGRIAL ne pourra être tenue responsable en cas d’indisponibilité du Site pour quelque cause que ce soit aux contenus des documents.</p>

    <h3 class="secondary--text">
      7. Droit applicable
    </h3>

    <p>Le Site et son contenu sont créés conformément aux droit et règles applicables en France. Même s’il est accessible par d’autres utilisateurs, le Site et son contenu sont destinés à l’accès et l’utilisation des résidents français.</p>

    <i>Dernière mise à jour le 09.12.2020</i>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<style lang="scss" scoped>
.content {
  margin: 3vw;
  padding: 2vw;
  background-color: #f4f8f9;
}

.secondary--text {
  font-weight: 300;
  text-decoration: underline;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .content {
    margin: 0;
    padding: 3vw;
  }
}
</style>
